import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import reportService from '../../services/ReportService';
import { ReportResponse, ReportState } from '../../types/Report.types';

// Async thunk for fetching report data
export const fetchReportData = createAsyncThunk(
  'report/fetchReportData',
  async (questionnaireId: string, { rejectWithValue }) => {
    try {
      const data = await reportService.getReport(questionnaireId);
      return data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : 'An unknown error occurred'
      );
    }
  }
);

const initialState: ReportState = {
  data: null,
  loading: false,
  error: null,
};

const reportSlice = createSlice({
  name: 'report',
  initialState,
  reducers: {
    clearReport: (state) => {
      state.data = null;
      state.error = null;
      state.loading = false;
    },
    clearError: (state) => {
      state.error = null;
    },
    setReportData: (state, action: PayloadAction<ReportResponse>) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchReportData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchReportData.fulfilled,
        (state, action: PayloadAction<ReportResponse>) => {
          state.loading = false;
          state.data = action.payload;
          state.error = null;
        }
      )
      .addCase(fetchReportData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearReport, clearError, setReportData } = reportSlice.actions;
export default reportSlice.reducer;
